<app-admin-header></app-admin-header>

<div class="details-wrapper">
  <app-admin-sidebar></app-admin-sidebar>

  <h2>👤 Patient Details</h2>

  <div *ngIf="patient" class="patient-info">
    <p><strong>Full Name:</strong> {{ patient.surname }} {{ patient.other_names }}</p>
    <p><strong>Sex:</strong> {{ patient.sex }}</p>
    <p><strong>Age:</strong> {{ patient.age }}</p>
    <p><strong>Hospital ID:</strong> {{ patient.hospital_id }}</p>
    <p><strong>Phone:</strong> {{ patient.phone }}</p>
    <p><strong>Email:</strong> {{ patient.email }}</p>
    <p><strong>Type:</strong> {{ patient.type }}</p>
    <p><strong>Allergic:</strong> {{ patient.allergic || '—' }}</p>
    <p><strong>Company:</strong> {{ patient.company_name || '—' }}</p>
    <p *ngIf="patient.type === 'in-patient'"><strong>Ward:</strong> {{ wardName }}</p>
    <p><strong>Registered On:</strong> {{ patient.created_at | date: 'medium' }}</p>
  </div>

  <h3>💊 Issued Drugs</h3>

  <!-- Filters -->
  <div class="filters">
    <label>
      From:
      <input type="date" [(ngModel)]="startDate" (change)="applyFilters()" />
    </label>
    <label>
      To:
      <input type="date" [(ngModel)]="endDate" (change)="applyFilters()" />
    </label>
    <label>
      Drug:
      <input type="text" [(ngModel)]="drugSearchTerm" (input)="applyFilters()" placeholder="Search drug..." />
    </label>
    <label>
      Store:
      <input type="text" [(ngModel)]="storeSearchTerm" (input)="applyFilters()" placeholder="Search store..." />
    </label>
  </div>

  <!-- Issued Drugs Table -->
  <table *ngIf="filteredIssues.length > 0">
    <thead>
      <tr>
        <th>Drug</th>
        <th>Quantity</th>
        <th>Store</th>
        <th>Note</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let i of filteredIssues">
        <td>{{ i.stock_item_name }}</td>
        <td>{{ i.quantity }}</td>
        <td>{{ i.store_name }}</td>
        <td>{{ i.note || '—' }}</td>
        <td>{{ i.created_at | date: 'short' }}</td>
      </tr>
    </tbody>
  </table>

  <p *ngIf="filteredIssues.length === 0">No drugs match your filter.</p>
</div>
